export default __webpack_public_path__ + "alberta-contact-data.dc34b9a4212ea11085fb.svg";